import ApplicationEndedPage from "./ApplicationEndedPage";

export default ApplicationEndedPage;
